import VueJSSIP from "@/packages/vue-jssip/";
export const jssip = new VueJSSIP({
  server: import.meta.env.VITE_SIP_DOMAIN,
  socket: import.meta.env.VITE_SIP_SOCKET,
  password: import.meta.env.VITE_SIP_PASSWORD,
});
